import i18n, { setLocale } from '@/i18n';
import { type SharedData } from '@/types';
import { createInertiaApp } from '@inertiajs/vue3';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';

// It is recommended to import a default layout component if you have one
// import DefaultLayout from './Layouts/DefaultLayout.vue'; // Example

const resolvePageComponent = (name: string) => {
    const page = require(`./pages/${name}.vue`).default;
    return page;
};

createInertiaApp({
    resolve: resolvePageComponent,
    setup({ el, App, props, plugin }) {
        const currentLocale =
            (props.initialPage.props as unknown as SharedData).auth?.user?.language || 'da';
        setLocale(currentLocale);

        const pinia = createPinia();

        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .use(ZiggyVue)
            .use(VueQueryPlugin)
            .use(pinia)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
